import { IIndex } from '../interfaces/IIndex'
import { indexesConfig } from '../config/indexesConfig'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface IndexesState {
  indexes: Array<IIndex>
}

export const indexesInitialState: IndexesState = {
  indexes: indexesConfig
}

export const indexesSlice = createSlice({
  name: 'indexes',
  initialState: indexesInitialState,
  reducers: {
    setIndexes: (state, action: PayloadAction<Array<IIndex>>) => {
      state.indexes = action.payload
    }
  }
})

export const { setIndexes } = indexesSlice.actions

export default indexesSlice.reducer
